export default __webpack_public_path__ + "static/media/imageEditor.fc3f677c.svg";